var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAisle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.21L12.0675 6L21.1875 12.21L12.09 18.69L3 12.21Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.645 14.04C13.0012 14.04 13.29 13.7512 13.29 13.395C13.29 13.0388 13.0012 12.75 12.645 12.75C12.2888 12.75 12 13.0388 12 13.395C12 13.7512 12.2888 14.04 12.645 14.04Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.25L18 14.25",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8525 15.855C10.7347 15.8523 10.6202 15.8159 10.5225 15.75L9.975 15.3525L10.635 14.4375L10.8525 14.595L11.25 14.25L12.1065 14.91L11.25 15.75C11.1554 15.8165 10.9681 15.8531 10.8525 15.855ZM9.3525 14.91L8.1825 14.0625L8.8425 13.155L10.0575 14.0325L9.3525 14.91ZM7.545 13.605L6.3225 12.7275L6.9825 11.8125L8.1825 12.7125L7.545 13.605ZM5.715 12.285L4.5 11.4075L5.16 10.5L6.375 11.3775L5.715 12.285Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAisle);
export default __webpack_public_path__ + "static/media/Aisle.82f3a83c.svg";
export { ForwardRef as ReactComponent };